import React from 'react';
import AboutMe from 'common/designer-modules/page-template/about-me';
import Footer from 'common/designer-modules/modules/footer';

import PropTypes from 'prop-types';

const PreviewAboutMe = ({
   isMobile,
   globalSettings,
}) => {
   return (
      <div>
         <AboutMe
            globalSettings={ globalSettings }
            isMobile={ isMobile }
         />
         <Footer />
      </div>
   )
}

PreviewAboutMe.propTypes = {
   isMobile: PropTypes.bool,
   globalSettings: PropTypes.object,
}

export default PreviewAboutMe;
